import { render, staticRenderFns } from "./charmPlan.vue?vue&type=template&id=71b971c7"
import script from "./charmPlan.vue?vue&type=script&lang=js"
export * from "./charmPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71b971c7')) {
      api.createRecord('71b971c7', component.options)
    } else {
      api.reload('71b971c7', component.options)
    }
    module.hot.accept("./charmPlan.vue?vue&type=template&id=71b971c7", function () {
      api.rerender('71b971c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/charm/plan/charmPlan.vue"
export default component.exports